
export class EdesignConstants {
    public static ProductSupportSpecId = 'ProductSupportSpecId';
    public static primaryKeyForDeviceId = 'primaryKeyForDeviceId';
    public static PRODUCT_TYPES = {
        ENCLOSURE: 'ENCLOSURE'
    };
    public static AllowedCharsRegEx = /[\w ,!@#$%^&*(){}]/;
    public static POLE_TYPES = {
        Pole_1P: 1,
        Pole_1P_N: 2,
        Pole_2P: 3,
        Pole_3P: 4,
        Pole_4P: 5,
        Pole_1L: 6,
        Pole_1L_N: 7,
        Pole_3L: 8,
        Pole_2_phases: 9,
        Pole_3_phases: 10,
        Pole_1P_Ns: 11,
        Pole_3P_N: 12,
        Pole_3LN: 13,
        Pole_1LN: 14,
        Pole_2L: 15,
        Pole_1UM: 16,
        Pole_2UM: 17,
        Pole_1NO: 18,
        Pole_4L: 27,
        Pole_NA: 0
    };
    public static BUS_BAR_TYPES = {
        CLARIO_1LN: 15,
        CLARIO_FI: 34
    };
    public static Groups = {
        CLARIO : 1,
        NON_CLARIO: 2
    };
    public static SNC_NO_PRODUCT_IMAGE = ['A9N19774', 'VME314M0', '87003.FLF.61', '2211-50.FLF', 'KLEMME_1LN', 'KLEMME_3LN',
      'KLEMME_3LN_PE', 'KLEMME_1LN_PE'];
    public static APP_CONSTANTS = {
      DOOR: 19,
      KITS: 22,
      DIN: 25,
      MEDIA: 26,
      DOORS_DISCONNECTORS: 23,
      OPTIONS: 24,
      FIELD_SEPERATOR: 27,
      PRAGMA_MULTI_UP: 6,
      PRAGMA_MULTI_AP: 7,
      DELIVERY: 8,
      MCB: 1,
      RCD: 2,
      RCBO: 3,
      SPD: 29,
      INCOMER: 32,
      BUSBAR: 5,
      RCBOS: 2,
      DUAL: 3,
      FEEDER: 4,
      CONSUMERS: 5,
      FLUSH_ENCLOSURE: 7,
      RECESSED_ENCLOSURE_UNIVERSAL: 10,
      SURFACE_ENCLOSURE: 15,
      Einspeise_FI_für_Clario: 4,
      FI_Vigi: 24,
      Einspeise_FI_Vigi: 36,
      Schrittschalter: 35,
      SWITCHING_DEVICES: 34,
      ACCESSORY: 28,
      Einspeiseblock: 19,
      TERMINAL_BLOCKS: 35,
      DEFAULT_ENCLOSURE: 339,
      Install_Schütz_2P: 48,
      Schütze_Tag_Nacht_1LN: 49,
      Hauptschalter: 37
  };
  public static MOUNTING_TYPE_ID = 5;
  public static TERMINAL_BLOCKS = 15;
}
